import React, { useEffect, useState } from 'react';
import Skeleton from 'components/Skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { pendingUserRequest, unverifiedUserRequest } from './unverifiedUsersSlice';
import CustomTable from 'components/CustomTable';
import { Grid } from '@material-ui/core';
import { showLoader } from 'utils';


const UnverifiedUser = () => {
  const dispatch = useDispatch();

  const loading = useSelector(state => state.unVerifiedUser.loading);
  const totalUnVerifiedUser = useSelector(
    state => state.unVerifiedUser.totalList
  );
  const unVerifiedUserList = useSelector(
    state => state.unVerifiedUser.unverifiedUser
  );

  const [allUnVerifiedUser, setAllUnVerifiedUser] = useState([]);

  console.log(totalUnVerifiedUser, 'totalUnVerifiedUser');
  console.log(allUnVerifiedUser, 'allUnVerifiedUser');

  useEffect(() => {
    if (Object.values(unVerifiedUserList).length) {
      setAllUnVerifiedUser(Object.values(unVerifiedUserList));
    }
  }, [unVerifiedUserList]);


  const getUnVerifiedUsers = (start, keyword, fromDate, toDate, sortBy, sortType) => {
    const obj = {
      keyword: keyword || '',
      fromDate: fromDate || '',
      toDate: toDate || '',
      sortBy: sortBy || '',
      sortType: sortType || '',
      type: 'unverified',
    };
    dispatch(
      unverifiedUserRequest({
        data: obj,
        start: start || 0,
        limit: 10,
      })
    );
  };


  const movePendingUser = (start, id, type, val) => {
    console.log(id, 'movePendingUser');
    dispatch(pendingUserRequest({
      data: {
        userIds: [id],
        status: type,
        fromPending: val,
      }
    }));
    setTimeout(() => {
      getUnVerifiedUsers(start);
    }, 1000);
  };

  return (
    <Skeleton>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomTable
            tableBodyData={allUnVerifiedUser}
            getAllUsers={getUnVerifiedUsers}
            type='unverify'
            movePendingUser={movePendingUser}
            totalUser={totalUnVerifiedUser}
          />
        </Grid>
      </Grid>
      {showLoader(loading, 'transparent')}
    </Skeleton>
  );
};

export default UnverifiedUser;
